
import { defineComponent } from 'vue';
import VueDragResize from 'vue-drag-resize';

export default defineComponent({
  props: ['tableHeight', 'tableWidth', 'resizeActive', 'onResizing', 'onResizstop', 'loading'],
  components: {
    VueDragResize,
  },
});
